import { Col, Modal, Row } from "react-bootstrap";
import React from "react";
// import { render } from "react-dom";
import warning from "../../Assets/Images/warning.png";

function DeleteModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size="lg" centered>
      <Modal.Header/>
        <Modal.Body>
          <div className="text">
            <h1> WARNING! </h1>
            <div className="text-wrapper">
              <div className="text-group">
                <h2>Are you sure you want to {props.isCancel ? "cancel" : "delete"} this {props.text}?</h2>
                <h3> The {props.text}’s details will be deleted immediately.</h3>
                <h3>You can’t undo this action. </h3>
                {
                  props.isCancel && (
                    <input type="text" name="reason" className="reason-modal-input" placeholder="State reason" onChange={(e) => props.setReason(e.target.value)}/>  
                  )
                }
              </div>
              <img src={warning} alt="warning" className="warning"></img>
            </div>
            <Row className=" pt-4" >
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col className="cancel-btn text-center me-1" onClick={props.onHide}>
                      {props.isCancel ? "CLOSE" : "CANCEL"}
                {/* <Button className="cancel-btn" onClick={()=>setOpenAuthorizeModal(false)}>CANCEL</Button> */}
              </Col>  
              <Col className="save-btn text-center" onClick={props.onDelete}>
                {props.isCancel ? "PROCEED" : "DELETE"}
                {/* <Button className="save-btn" onClick={submit}>SUBMIT</Button> */}
              </Col>
            </Row>
            {/* <div className="row">
              <div className="col-sm-6 mt-3 d-flex justify-content-end"></div>
              <div className="col-sm-3 cancel-btn">
                <button className="cancel-btn me-3" onClick={props.onHide}>
                  {props.isCancel ? "CLOSE" : "CANCEL"}
                </button>
              </div>
              <div className="col-sm-3 mt-3 d-flex justify-content-end">
                <button className="save-btn" onClick={props.onDelete}>
                  {props.isCancel ? "PROCEED" : "DELETE"}
                </button>
              </div>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

DeleteModal.defaultProps = {
  text: "",
  // type:"",
  // size: "lg",
  show: () => {},
  onHide: () => {},
  onDelete: () => {},
};

export default DeleteModal;